import store from '../store';

const pushLog = (log) => {
  store.dispatch({ type: 'logs/appendLog', payload: { log } });
};

export default pushLog;
